declare global {
  interface Window {
    wiremesh: any;
  }
}

window.wiremesh = window.wiremesh || {};

const Server = {
  getVar: (name: any) => {
    if (!window.wiremesh || !window.wiremesh.vars) {
      return undefined;
    }
    return window.wiremesh.vars[name];
  },
};

export default Server;
